import classNames from "classnames";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import AutoSuggest from "react-autosuggest";

import { ApiService, ZsdCode } from "pwapi";

type ZSDInputProps = {
  zsd: string;
  zsdError: boolean;
  setZsd: Function;
  setZsdError: Function;
  placeholder?: string;
};

const ZSDInput = (props: ZSDInputProps) => {
  const [zsdCodes, setZsdCodes] = useState<ZsdCode[]>([]);
  const [suggestions, setSuggestions] = useState<ZsdCode[]>([]);
  const [dirty, setDirty] = useState(false);

  const fetchZsdCodes = async (value: string) => {
    const responseCodes = await ApiService.listZsdCodes({ code: value });
    setZsdCodes(responseCodes.results || []);
  };

  const onSuggestionsFetchRequested = useCallback(
    debounce(
      ({ value }) => {
        fetchZsdCodes(value);
      },
      500,
      { leading: true, trailing: true }
    ),
    []
  );

  useEffect(() => {
    dirty && setError(props.zsd);
  }, [props.zsd, zsdCodes, dirty]);

  useEffect(() => {
    setSuggestions(zsdCodes);
  }, [zsdCodes]);

  const setError = (value: string) => {
    props.setZsdError(getError(value, zsdCodes));
  };

  const getError = (value: string, codeList: ZsdCode[]) => {
    const error =
      value !== "" && !codeList.some((code: ZsdCode) => code.code === value);
    return error;
  };

  const handleOnChange = (newValue: string) => {
    setDirty(true);
    props.setZsd(newValue);
  };

  return (
    <div
      className={classNames({
        input__error: props.zsdError,
        "input__error--top": props.zsdError,
      })}
    >
      <label className="BillingCode__label" htmlFor="ZSDInput__input">
        ZSD
      </label>

      <AutoSuggest
        suggestions={suggestions}
        getSuggestionValue={(suggestion: ZsdCode) => suggestion.code}
        inputProps={{
          id: "ZSDInput__input",
          name: "ZSDInput__input",
          className: "ZSDInput__input",
          alt: "zsd-alt",
          placeholder: props.placeholder,
          value: props.zsd,
          onChange: (_, { newValue }) => {
            handleOnChange(newValue);
          },
        }}
        renderSuggestion={(suggestion) => <p>{suggestion.code}</p>}
        onSuggestionsClearRequested={() => {
          setSuggestions([]);
        }}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        renderInputComponent={(inputProps) => (
          <div className="ZSDInput__grow">
            {/* @ts-ignore */}
            <textarea {...inputProps} rows="1" />
            <div className="ZSDInput__grower" aria-hidden="true">
              {inputProps.value || inputProps.placeholder}{" "}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default ZSDInput;
